// features/cutsheets/wizard/wizard-step.tsx
import { StepConfig, WizardContext } from './types';
import { Box, Typography } from '@mui/material';
import { LazyLoadingImage } from '@farmshare/ui-components';

export function WizardStep({
  config,
  context,
}: {
  config: StepConfig<WizardContext>;
  context: WizardContext;
}) {
  const content =
    typeof config.content === 'function'
      ? config.content(context)
      : config.content;

  return (
    <Box sx={{ color: 'text.primary' }}>
      <Typography
        variant="h4"
        component="h4"
        color="primary.main"
        sx={{
          fontWeight: 'bold',
          textAlign: config.id === 'intro' ? 'center' : 'left',
        }}
      >
        {config.title}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          gap: 2,
          mt: 2,
        }}
      >
        {config.imageUrl && (
          <LazyLoadingImage
            src={config.imageUrl}
            alt={config.title}
            variant="rounded"
            size={120}
            skeletonVariant="rounded"
            rootMargin="100px"
            sx={{
              flexShrink: 0,
            }}
          />
        )}
        {config.subHead && (
          <Typography
            variant="h6"
            color="text.disabled"
            sx={{ fontWeight: 400, mb: 1.5 }}
          >
            {config.subHead}
          </Typography>
        )}
      </Box>
      {config.instructions && (
        <Typography
          variant="body1"
          color="primary.main"
          sx={{ fontWeight: 400, p: 2, textAlign: 'center' }}
        >
          {config.instructions}
        </Typography>
      )}
      {content}
    </Box>
  );
}
